// extracted by mini-css-extract-plugin
export default {"content":"style_content__Z7ndG","leftSide":"style_leftSide__GFXOE","rightSide":"style_rightSide__ocyRx","type":"style_type__-0tj3"};